import { c as _c } from "react/compiler-runtime";
import { TextField, type TextFieldProps } from "@navikt/ds-react";
import { useFieldContext } from "@/shared/components/form/hooks/form-context";
export type TextInputFieldProps = {
  label: string;
  type?: TextFieldProps["type"];
  className?: string;
  uiSelector?: string;
  isRequired?: boolean;
};
export function TextInputField(t0) {
  const $ = _c(12);
  const {
    label,
    type,
    className,
    uiSelector,
    isRequired: t1
  } = t0;
  const isRequired = t1 === undefined ? false : t1;
  const field = useFieldContext();
  let t2;
  if ($[0] !== field) {
    t2 = e => field.handleChange(e.target.value);
    $[0] = field;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = field.state.meta.errors[0]?.message;
  const t4 = uiSelector ?? field.name;
  let t5;
  if ($[2] !== className || $[3] !== field.handleBlur || $[4] !== field.state.value || $[5] !== isRequired || $[6] !== label || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== type) {
    t5 = <TextField label={label} value={field.state.value} onChange={t2} onBlur={field.handleBlur} error={t3} type={type} className={className} data-testid={t4} aria-required={isRequired} />;
    $[2] = className;
    $[3] = field.handleBlur;
    $[4] = field.state.value;
    $[5] = isRequired;
    $[6] = label;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = type;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}